import React, { useState, useEffect } from "react";
import { CreateButton } from "../utils/Buttons";
import CreateProject from "../components/Projects/CreateProject";
import Drawer from "../components/Drawer";
import AdminProjectCard from "../components/Projects/AdminProjectCard";
import { useAppLibs } from "../ContextProvider/AppLib_Provider";
import { useToast } from "../components/ToastContext";
import ProjectDetailsAndSubmissions from "../components/Projects/ProjectDetailsAndSubmissions";
import EditProjectCard from "../components/Projects/EditProjectCard";

const AdminProjectsDashboard = () => {
  const [projects, setProjects] = useState([]);
  const [renderProjects, setRenderProjects] = useState(false);
  const { Projects } = useAppLibs();
  const LEVEL = Projects.LEVEL;
  const SUBJECT = Projects.SUBJECT;
  const showToast = useToast();

  const initialDrawerState = {
    isOpen: false,
    Component: null,
    componentProps: {},
  };
  const [drawerState, setDrawerState] = useState(initialDrawerState);

  const openDrawer = function (Component, componentProps = {}) {
    setDrawerState({ isOpen: true, Component, componentProps });
  };

  const openCreateForm = () => {
    openDrawer(CreateProject, {
      projects,
      setProjects,
      width: "60%",
      onClose: closeDrawer,
    });
  };

  const handleOpenProject = (item) => {
    openDrawer(ProjectDetailsAndSubmissions, {
      item,
      onClose: closeDrawer,
    });
  };
  const handleEditAssignment = (item, index) => {
    openDrawer(EditProjectCard, {
      item,
      index,
      setProjects,
      onClose: closeDrawer,
    });
  };

  const closeDrawer = () => {
    setDrawerState(initialDrawerState);
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const result = await Projects.getAllProjects();
        if (result.success) {
          setProjects(result.data);
          setRenderProjects(true);
        } else {
          showToast(result.error, "error", true, 3000);
        }
      } catch (error) {
        showToast(error.message, "error", true, 3000);
      }
    };
    fetchProjects();
  }, []);

  return (
    <div className="shadow-none p-4 overflow-y-auto overflow-x-hidden space-y-4 h-[calc(100vh-65px)]">
      <div className="flex justify-between" key="CreateButton">
        <CreateButton name={"Project"} onClick={openCreateForm} />
      </div>

      <div
        className={`w-full transition-transform duration-700 ease-in-out transform ${
          renderProjects
            ? "translate-x-0 opacity-100"
            : "translate-x-[-100%] opacity-0"
        }`}
        key={"AdminAssignmentsContainer"}
      >
        {projects.map((item, index) => (
          <AdminProjectCard
            item={item}
            index={index}
            onEdit={() => handleEditAssignment(item, index)}
            onView={() => handleOpenProject(item)}
            onClose={() => closeDrawer}
            setProjects={setProjects}
          />
        ))}
      </div>

      <Drawer props={{ ...drawerState, closeFn: closeDrawer }} />
    </div>
  );
};

export default AdminProjectsDashboard;
